export const actions = {
    START_REQUEST: "START_REQUEST",
    GET_APP_SETTINGS: "GET_APP_SETTINGS",
    HANDLE_ERROR: "HANDLE_ERROR",
    CLEAR_ERROR: "CLEAR_ERROR",
    END_REQUEST: "END_REQUEST",
    CHANGE_APP_LANGUAGE: "CHANGE_LANGUAGE"
};

export const api= {
    GET_APP_SETTINGS: "/api/app/settings"
}

//export default appConstants =
//{
//    actionTypes,
//    api
//}